import { FixedCard } from "../CommonComponents/DataCard";

function UserCard({ user, onClick }) {
    return (
        <FixedCard width="450px" height="50px"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
            }}
            onClick={onClick}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",

                }}
            >
                <p style={{ flex: 1, textAlign: "center", borderRight: "1px solid #ccc", }}>{user.id}</p>
                <p style={{ flex: 1, textAlign: "center", borderRight: "1px solid #ccc", }}>{user.username}</p>
                <p style={{ flex: 1, textAlign: "center", borderRight: "1px solid #ccc", }}>{user.name}</p>
                <p style={{ flex: 1, textAlign: "center" }}>{user.surname}</p>
            </div>
        </FixedCard>
    );
}

export default UserCard;